// 必须在最前面导入 React 19 补丁，确保在 antd 之前加载
// 使用动态导入确保补丁在模块加载时立即执行
import '@ant-design/v5-patch-for-react-19';

// 确保补丁已加载
if (typeof window !== 'undefined') {
  // 在浏览器环境中，确保补丁已执行
  (window as any).__ANTD_PATCH_LOADED__ = true;
}

// 导入 ReactDOM（在 antd 相关导入之前）
import ReactDOM from 'react-dom/client';

// 导入其他样式（在 antd 相关导入之前）
import '@/assets/css/public.less';
import '@/assets/fonts/font.less';
import 'uno.css';
import 'nprogress/nprogress.css';
import '@/assets/css/scrollbar.less';
import '@/assets/css/theme-color.less';
import '@/assets/css/antd.less';

// 国际化i18n
import './locales/config';

// 导入路由（在样式和 antd 之后）
import Router from './router';

// 时间设为中文
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

// 导入 StyleProvider（使用更新后的 @ant-design/cssinjs 2.0.1）
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

// 延迟渲染，确保所有模块都已初始化
setTimeout(() => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
      <Router />
    </StyleProvider>
  );
}, 0);

// 关闭loading
const firstElement = document.getElementById('first');
if (firstElement && firstElement.style?.display !== 'none') {
  firstElement.style.display = 'none';
}
